import React from 'react';
import { Box, Grid, Container } from '@mui/material';
import {
  SectionTitle,
  EventAndRidesCardV2,
  Carousel,
} from 'views/rebranded-module/common/components';
import StyledBox from 'views/rebranded-module/location-module/LocationViewV2/components/RentalsSection/RentalsSection.styles';
import { interpolateString } from 'views/rebranded-module/common/utils/interpolateString';
import PATHS from 'lib/navigation/paths';

const EventAndRidesSectionV2 = (props) => {
  const {
    content, events, rides, location,
  } = props;
  // Get first event and first attraction
  const firstEvent = events[0];
  const firstRide = rides[0];
  // Combine into an array array
  const combinedEventsAndRides = [];

  if (firstEvent) {
    combinedEventsAndRides.push({
      title: firstEvent.name,
      startDateDay: firstEvent.start_date_day,
      startDateMonth: firstEvent.start_date_month,
      image: firstEvent.image_url,
      path: PATHS.motorcycleEvents.slug(firstEvent.slug),
      featured: firstEvent.featured,
    });
  }

  if (firstRide) {
    combinedEventsAndRides.push({
      title: firstRide.title,
      image: firstRide.image_url,
      path: PATHS.motorcycleRides.slug(firstRide.slug),
      featured: firstRide.featured,
    });
  }

  const getEventAndRidesCardSectionDescription = () => {
    // Prepare base values
    const values = {
      location: location.display_name,
      ridesCount: rides.length,
      eventsCount: events.length,
      count: rides.length || events.length,
    };

    // Handle pluralization for rides and events
    const pluralize = (count, singular, plural) => (count === 1 ? singular : plural);

    // Get the appropriate template from CMS content
    let template;
    if (rides.length > 0 && events.length > 0) {
      template = content.eventsAndRidesSubtitleHasCountInLocation;
      values.rides = pluralize(rides.length, content.ride, content.rides);
      values.events = pluralize(events.length, content.event, content.events);
    } else if (rides.length > 0) {
      template = content.ridesSubtitleHasCountInLocation;
      values.rides = pluralize(rides.length, content.ride, content.rides);
    } else if (events.length > 0) {
      template = content.eventsSubtitleHasCountInLocation;
      values.events = pluralize(events.length, content.event, content.events);
    }
    return interpolateString(template, values);
  };
  return (
    <StyledBox>
      <Container className="LVCustomContainer">
        <Box className="TSContent">
          <SectionTitle
            title={content.eventsAndRidesTitle}
            text={getEventAndRidesCardSectionDescription()}
          />
          <Box className="IRSSectionContainer" mt={4}>
            <Box position="relative" className="showDESKTOP">
              <Carousel
                arrowOutside
                swipeable
                infinite
                showDots={false}
                keyBoardControl
                minimumTouchDrag={20}
                renderDotsOutside
                deskTopItems={2}
                carouselArrow
                customTransition="transform 200ms ease-in">
                {combinedEventsAndRides.map((item) => (
                  <EventAndRidesCardV2
                    key={item.name}
                    image={item.image}
                    title={item.title}
                    startDateDay={item.startDateDay}
                    startDateMonth={item.startDateMonth}
                    path={item.path}
                    isFeatured={item.featured}
                  />
                ))}
              </Carousel>
            </Box>

            <Box className="showTABLET">
              <Grid container rowSpacing={4} columnSpacing={2}>
                {combinedEventsAndRides.map((item) => (
                  <Grid item md={6} sm={12} key={item.name}>
                    <EventAndRidesCardV2
                      image={item.image}
                      title={item.title}
                      startDateDay={item.startDateDay}
                      startDateMonth={item.startDateMonth}
                      path={item.path}
                      isFeatured={item.featured}
                    />
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
    </StyledBox>
  );
};

export { EventAndRidesSectionV2 };
